import React from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { useTranslation } from '../i18n';
export function PrivacyPolicyPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-1951">
      <section className="bg-teal-900 text-white py-16" data-id="element-1952">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1953">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1954">
            Privacy Policy
          </h1>
          <p className="text-teal-100" data-id="element-1955">Last updated: 5 February 2026</p>
        </div>
      </section>

      <section className="py-16 bg-gray-50" data-id="element-1956">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1957">
          <Card className="p-8 md:p-12 prose prose-teal max-w-none" data-id="element-1958">
            <p className="lead" data-id="element-1959">
              Dentico Dental Clinic Ltd is committed to protecting your privacy
              and handling personal data transparently and securely.
            </p>

            <div className="bg-teal-50 p-6 rounded-xl my-8 not-prose" data-id="element-1960">
              <h3 className="text-lg font-bold text-teal-900 mb-2" data-id="element-1961">
                Data Controller
              </h3>
              <p className="text-teal-800" data-id="element-1962">Dentico Dental Clinic Ltd</p>
              <p className="text-teal-800" data-id="element-1963">Company No.: 15399534</p>
              <p className="text-teal-800" data-id="element-1964">
                Address: 360–364 City Road, London EC1V 2PY, United Kingdom
              </p>
              <p className="text-teal-800" data-id="element-1965">Email: info@denticoclinic.co.uk</p>
              <p className="text-teal-800" data-id="element-1966">Phone: +44 7345 197820</p>
            </div>

            <h3 data-id="element-1967">We may collect:</h3>
            <ul data-id="element-1968">
              <li data-id="element-1969">
                name, phone number, email address, enquiry/booking details,
              </li>
              <li data-id="element-1970">
                technical website data (IP, browser/device, pages viewed),
              </li>
              <li data-id="element-1971">any data you voluntarily submit via website forms.</li>
            </ul>

            <h3 data-id="element-1972">We use your data to:</h3>
            <ul data-id="element-1973">
              <li data-id="element-1974">respond to enquiries and appointment requests,</li>
              <li data-id="element-1975">manage bookings and communications,</li>
              <li data-id="element-1976">improve our website and services,</li>
              <li data-id="element-1977">send marketing updates only where consent is provided,</li>
              <li data-id="element-1978">comply with legal and regulatory obligations.</li>
            </ul>

            <h3 data-id="element-1979">Lawful bases include:</h3>
            <ul data-id="element-1980">
              <li data-id="element-1981">contract / steps at your request before contract,</li>
              <li data-id="element-1982">legal obligation,</li>
              <li data-id="element-1983">legitimate interests,</li>
              <li data-id="element-1984">consent (where required, e.g. marketing/certain cookies).</li>
            </ul>

            <h3 data-id="element-1985">Data Sharing & Retention</h3>
            <p data-id="element-1986">
              We do not sell your personal data. We may share data with trusted
              service providers (IT/hosting/booking/analytics/professional
              advisers) only where necessary and lawful.
            </p>
            <p data-id="element-1987">
              We retain personal data only as long as needed for the purposes
              collected and in line with legal/regulatory requirements.
            </p>

            <h3 data-id="element-1988">Your Rights</h3>
            <p data-id="element-1989">
              You have rights to access, rectify, erase (where applicable),
              restrict, object, data portability, and withdraw consent where
              consent is used.
            </p>

            <div className="border-t border-gray-200 pt-8 mt-8" data-id="element-1990">
              <p data-id="element-1991">
                For privacy requests, contact:{' '}
                <a href="mailto:info@denticoclinic.co.uk" className="text-teal-600 font-medium hover:underline" data-id="element-1992">
                  info@denticoclinic.co.uk
                </a>
              </p>
            </div>
          </Card>
        </div>
      </section>
    </Layout>;
}